import axios from 'axios'
import errorHandler from './error-handler'

const ROTA = 'https://app.bembomsalgados.com.br/teleentrega/empresas'

export default {
  async cadastrar(cargoDto) {
    try {
      await axios.post(`${ROTA}`, cargoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async atualizar(cargoDto) {
    try {
      await axios.put(`${ROTA}`, cargoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPorId(produtoId) {
    try {
      const { data } = await axios.get(`${ROTA}/filtrar-id/${produtoId}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
}
